var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomizeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 40,
    viewBox: "0 0 47 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 39.48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_828_544",
    transform: "scale(0.01 0.0119048)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_828_544",
    width: 100,
    height: 84,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABUCAYAAAB0mJL5AAAAAXNSR0IArs4c6QAAAvBJREFUeF7tm1GOwkAMQ+n9D90VSKwQAupM4sQF89tpmvjFmYGK7eKPlAKbVDZO5mIgYk1gIAYipoBYOnaIgYgpIJaOHWIgYgqIpWOHGIiYAmLpSDtk3/d9Ra9t26Tr+lSTVOKrAI6gnQnQOBAWhHeQ1OGMAYmCQISMxETiHTmPcb0dCCpaVrCu51RDaQWCiJQF8SwQ8szrPdXPXQXVAkRBFCQHBSh0IEpCKOXy9tCxai3kPkUBFHN61JLmEPXCj/KbGl8UIEfF3jtiqujr85EcJ/IrB4IUqnKqQXLthjICpLvIT/udGpRSIGrFnfHgUQYEgaEyqla+PHa5uhVIV1GIMx7XKDVTCRClgqIw7uuRGjoaqg1IRzGrMNBjcMfITQNBOqujkAwMJZe0AFF3RwQIu7lSQL7JHSpjy0CeZh3SZEzHG8gCEObYWgaCdBIz8YpN/FWM6boMxA5h9XZNXDukRsfSKJNQPLJeoDSQ0v7OBzOQvIalEQykVM58MAPJa1gawUBK5cwHM5C8hqURDKRUznwwA8lrWBrBQErlzAczkLyGpREMpFTOXLBJGLfXFavpTye+mvfRfdN1LQO5FoYkz3zdeSTuynWkplsnk/4LTwfCTH5F8KN7DORIoebrCBCWO1J7CDqyzuQQBAa7ntTIQqEwO6rSQD8DhN1VVVAQIOzmSjvkW1yCwOhorDYgHcVknIIAYbsjvak/CqBS0AoUJPeuhipxCDq2uoqKQkGAdLij1CEolK7CUChKMMqBnA0KAqPb1WUjK7KfqLgEAdKd6wiQ7q57Nb4UYVBG1r141YLVxyrFIcrjS7lRqA5RhKIOow2Iwpg4A4xWIFNQzgLiPlHoe8jUCQcBoXDae9ZnBAjqlv+uAd9foxAUQYw6JLLhoz+BoOu6v+iheckA6YKjDkISSCWcswCQ2UOiVv6V9WOb+q8IHK3TQKKKkdcbCFngaHgDiSpGXm8gZIGj4Q0kqhh5vYGQBY6GN5CoYuT1f6ed6GRFemhnAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizeIcon);
export default __webpack_public_path__ + "static/media/customize-icon.8d2a33eabc4ec7b5b427de0bbe296e9f.svg";
export { ForwardRef as ReactComponent };